(function () {
  document.querySelectorAll('.cs-hero').forEach(initHero);

  function initHero(hero) {
    initCountdown(hero);
    initSoundToggle(hero);
  }

  /* ---------------- Countdown ---------------- */
  function initCountdown(hero) {
    var raw = hero.getAttribute('data-countdown');
    if (!raw) return;

    // Treat the configured date/time as UTC.
    var target = new Date(raw.indexOf('Z') === -1 ? raw + 'Z' : raw).getTime();
    if (isNaN(target)) return;

    var daysEl = hero.querySelector('[data-days]');
    var hoursEl = hero.querySelector('[data-hours]');
    var minutesEl = hero.querySelector('[data-minutes]');
    var secondsEl = hero.querySelector('[data-seconds]');

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      var now = Date.now();
      var diff = target - now;

      if (diff <= 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        hero.dispatchEvent(new CustomEvent('cs:countdown-complete'));
        clearInterval(timer);
        return;
      }

      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);

      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);
    }

    tick();
    var timer = setInterval(tick, 1000);
  }

  /* ---------------- Sound toggle ---------------- */
  function initSoundToggle(hero) {
    var btn = hero.querySelector('[data-cs-sound-toggle]');
    var video = hero.querySelector('.cs-hero__video');
    if (!btn || !video) return;

    var label = btn.querySelector('[data-cs-sound-label]');
    var onLabel = '♪ Sound On';
    var offLabel = label ? label.textContent : '♪ Sound';

    btn.addEventListener('click', function () {
      video.muted = !video.muted;
      var isOn = !video.muted;
      btn.setAttribute('aria-pressed', String(isOn));
      if (label) label.textContent = isOn ? onLabel : offLabel;

      // Some browsers require a user-gesture play() call after unmuting.
      if (isOn) {
        video.play().catch(function () {});
      }
    });
  }

})();